/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {getLayout, ILayout, LayoutSetup, useLayout} from '../../../_metronic/layout/core'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {Link, useNavigate} from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import swal from 'sweetalert'
import {CloseButton} from 'react-bootstrap'
import AddRemoveJadwal from './AddRemoveJadwal'
import {useTranslation, initReactI18next} from 'react-i18next'

import {
  getOrderDetail,
  updateSales,
  rejectSales,
  negoAll,
  negoSatuan,
} from '../../../api/modules/order'
import axios from 'axios'
import {create, getFile, deleteFile} from '../../../api/modules/file'
import dateformat from 'src/utils/dateformat'

const OrderDetailSales: React.FC = () => {
  const [showUpload, setShowUpload] = useState(false)
  const [showApprove, setShowApprove] = useState(false)
  const [showJadwal, setShowJadwal] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [hargaDisetujui, setHargaDisetujui] = useState(0)
  const [quantumDisetujui, setQuantumDisetujui] = useState(0)
  const [loadingUpdate, setLoadingUpdate] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleShow1 = async () => {
    ambilAttachment()
    setShowUpload(true)
  }

  const navigate = useNavigate()

  const [allFile, setAllFiles] = useState<any[]>([])
  const handleJadwal = (id: any) => {
    sessionStorage.setItem('sales', 'true')
    sessionStorage.setItem('id', id)
    setShowJadwal(true)
  }

  const Reject = async (id: any) => {
    await rejectSales(id, rejectNote).then((res) => {
      if (!res.data.error) {
        swal({
          title: `${t('rejectSuccess')}`,
          icon: 'success',
        })
        setShowReject(false)
      } else
        swal({
          title: `${res.data}`,
          icon: 'error',
        })
    })
  }

  const ambilAttachment = async () => {
    const res = await getFile(
      'header',
      parseInt(sessionStorage.getItem('po')!),
      localStorage.getItem('credential')!
    )
    setAllFiles(res.data.data)
  }

  const negoOne = async (id: any) => {
    await negoSatuan(id).then((res) => {
      swal({
        title: `${t('negoSatuanBerhasil')}`,
        icon: 'success',
      })
      navigate('/negotiate')
    })
  }

  const negoSemua = async () => {
    await negoAll(sessionStorage.getItem('id')).then((res) => {
      swal({
        title: `${t('negoSemuaBerhasil')}`,
        icon: 'success',
      })
      navigate('/negotiate')
    })
  }

  const handleUpdateSales = async (id: any) => {
    setLoadingUpdate(true)
    const temp = {
      fixed_price: hargaDisetujui,
      fixed_quantum: quantumDisetujui,
    }
    await updateSales(id, temp).then((res) => {
      if (!res.data.error) {
        swal({
          title: `${t('updateSuccess')}`,
          icon: 'success',
        })
        setLoadingUpdate(false)
        setShowApprove(false)
      }
    })
  }

  const {t} = useTranslation()

  const [rejectNote, setRejectNote] = useState({reason: ''})

  const [detailOrder, setDetailOrder] = useState<any[]>([])
  const [regarding, setRegarding] = useState('')

  useEffect(() => {
    const getDetail = async () => {
      const res = await getOrderDetail(
        sessionStorage.getItem('id'),
        localStorage.getItem('credential')
      )
      setDetailOrder(res.data.data.children)
      setRegarding(res.data.data.regarding)
    }
    getDetail()
  }, [])

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  return (
    <div className='card p-5'>
      {/* begin::Header */}
      <div>
        <p className='mt-5'>
          <i className='fw-normal'>
            {t('Order')}/<span className='text-primary fw-normal'>{t('order-judul')}</span>
          </i>
        </p>
        <h1 className='fw-semibold'>Detail Order Sales</h1>
      </div>
      <div>
        <div
          className='d-flex justify-content-between align-items-center'
          style={{marginTop: '3rem'}}
        >
          <div style={{width: '50%'}}>
            <Row className='mb-3'>
              <Col lg={4}>
                <p className='fs-4'>{t('order-perihal')}</p>
              </Col>
              <Col lg={8}>
                <Form.Control type='text' placeholder={t('Pembelian')} className='w-50' disabled />
              </Col>
            </Row>
          </div>
          {/* <table className='me-5'>
                            <tr>
                                <td>
                                    <p className='fs-4 me-2'>Status :</p>
                                </td>
                                <td>
                                    <i className='text-primary fs-4'>Completed</i>
                                </td>
                            </tr>
                        </table> */}
        </div>

        <div className='mt-3' style={{width: '50%'}}>
          <Row className='mb-3'>
            <Col lg={4}>
              <p className='fs-4'>{t('order-lampiran')}</p>
            </Col>
            <Col lg={8}>
              <Button variant='primary' onClick={handleShow1}>
                {t('order-lampiranUpload')}
              </Button>
              <Modal
                size='lg'
                show={showUpload}
                onHide={() => setShowUpload(false)}
                backdrop='static'
                keyboard={false}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('order-fileBox')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col sm={6} className='mt-3'>
                      {/* <span className='text-danger'>{t("File Exceed 2MB")}</span> */}
                    </Col>
                    <div className='table-responsive mt-4' style={{marginTop: '3rem'}}>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead className='fw-bold border-bottom'>
                          <tr className=''>
                            <th className='text-center'>{t('order-noo')}</th>
                            {/* <th className='text-center'>{t('order-namaFile')}</th>
                            <th className='text-center'>{t('order-jenisFile')}</th> */}
                            <th className='text-center'>{t('order-keterangan')}</th>
                            <th className='text-center'>{t('order-tglUpload')}</th>
                            {/* <th className='text-center'>{t('User Code')}</th> */}
                            <th className='text-center'>{t('order-user')}</th>
                            <th className='text-center'>{t('order-aksi')}</th>
                          </tr>
                        </thead>
                        {allFile.map((data: any, _index: number) => (
                          <tbody key={data?.id ?? _index}>
                            <tr className=''>
                              <td className='text-center'>
                                <label>{_index + 1}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>{data.name}</label>
                              </td>
                              <td className='text-center'>
                                <label>{t(data.file_type)}</label>
                              </td> */}
                              <td className='text-center'>
                                <label>{data.description}</label>
                              </td>
                              <td className='text-center'>
                                <label>{dateformat(data.updated_at)}</label>
                              </td>
                              {/* <td className='text-center'>
                                <label>
                                  {data.user?.customer_code || data.user?.nama_pengguna}
                                </label>
                              </td> */}
                              <td className='text-center'>
                                <label>
                                  {data.user?.customer_code || data.user?.nama_pengguna}
                                </label>
                              </td>
                              <td className='text-center'>
                                {data.user?.customer_code == null ? (
                                  <label>{data.user?.name}</label>
                                ) : (
                                  <label>{data.user?.customer?.name}</label>
                                )}
                              </td>
                              <td className='text-center'>
                                <button
                                  onClick={() =>
                                    window.open(
                                      data.file_path + `&token=${localStorage.getItem('token')}`
                                    )
                                  }
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  data-bs-trigger='hover'
                                  title={t('unduh')}
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrow-down-square-fill.svg'
                                    className='svg-icon-3'
                                  />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  </Row>
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col lg={4}>
              <p className='fs-4'>{t('order-dataPenunjang')}</p>
            </Col>
            <Col lg={8}>
              <Button variant='primary'>{t('order-lihat')}</Button>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col lg={4}>
              <p className='fs-4'>{t('order-reqHarga')}</p>
            </Col>
            <Col lg={8}>
              <Button variant='primary'>{t('order-lihat')}</Button>
            </Col>
          </Row>
        </div>

        <div className='table-responsive' style={{marginTop: '3rem'}}>
          {/* Table Head */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead className='border-bottom'>
              <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                <th className='td-order-1 text-center'>{t('sub-order-item')}</th>
                <th className='td-order-2 text-center'>Status</th>
                <th className='td-order-2 text-center'>{t('order-aksi')}</th>
                <th className='td-order-2 text-center'>Sales Org</th>
                <th className='td-order-2 text-center'>{t('sub-order-incoterm')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-jenis')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-produk')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-spek')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-hargaP')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-kuantum')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-wilayah')}</th>
                <th className='td-order-2 text-center'>{t('sub-order-gudang')}</th>
              </tr>
            </thead>
            {detailOrder.map((item, _index) => (
              <tbody key={item?.id ?? _index}>
                <tr className='d-flex jusify-content-center w-100 align-items-center'>
                  <td className='td-order-1 text-center'>{item['id']}</td>
                  <td className='td-order-2 text-center'>
                    <span className='d-block '>{t(item.status_text)}</span>
                  </td>
                  <td className='td-order-2 text-center'>
                    <div className='d-flex justify-content-center align-items-center'>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Jadwal')}
                        onClick={() => handleJadwal(item['id'])}
                      >
                        <KTSVG
                          path='/media/icons/duotune/calendar-check-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      <Modal
                        show={showJadwal}
                        onHide={() => {
                          sessionStorage.removeItem('sales')
                          setShowJadwal(false)
                        }}
                        centered
                        size='lg'
                        backdrop='static'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('Jadwal')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <AddRemoveJadwal id={3} is_amendment={'false'} />
                        </Modal.Body>
                      </Modal>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('order-tolak')}
                        onClick={() => setShowReject(true)}
                      >
                        <KTSVG
                          path='/media/icons/duotune/file-earmark-x-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      <Modal
                        show={showReject}
                        onHide={() => setShowReject(false)}
                        centered
                        backdrop='static'
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('alasan-tolak-order')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                            <Form.Control
                              as='textarea'
                              placeholder={t('Tinggal-pesan')}
                              style={{height: '100px'}}
                              onChange={(e: any) => setRejectNote({reason: e.target.value})}
                            />
                          </FloatingLabel>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant='secondary' onClick={() => setShowReject(false)}>
                            {t('order-tutup')}
                          </Button>
                          <Button variant='danger' onClick={() => Reject(item['id'])}>
                            Ok
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('Approve')}
                        onClick={() => setShowApprove(true)}
                      >
                        <KTSVG
                          path='/media/icons/duotune/file-earmark-check-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                      <Modal
                        show={showApprove}
                        onHide={() => setShowApprove(false)}
                        centered
                        backdrop='static'
                      >
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                          {!loadingUpdate && (
                            <>
                              <tr>
                                <td>
                                  <h6>{t('sub-order-hargaD')}</h6>
                                </td>
                                <td className='w-75'>
                                  <Form.Control
                                    type='number'
                                    placeholder={t('Enter Price')}
                                    onChange={(e: any) => setHargaDisetujui(parseInt(e.target.value))}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <h6>{t('sub-order-kuantumD')}</h6>
                                </td>
                                <td className='w-75'>
                                  <Form.Control
                                    type='number'
                                    placeholder={t('Enter quantum')}
                                    onChange={(e: any) => setQuantumDisetujui(parseInt(e.target.value))}
                                  />
                                </td>
                              </tr>
                            </>
                          )}

                          {loadingUpdate && (
                            <tr>
                              <label>Loading..</label>
                            </tr>
                          )}
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant='secondary' onClick={() => setShowApprove(false)}>
                            {t('order-tutup')}
                          </Button>
                          <Button variant='success' onClick={() => handleUpdateSales(item['id'])}>
                            Ok
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('ke_nego')}
                        onClick={() => negoOne(item['id'])}
                      >
                        <KTSVG
                          path='/media/icons/duotune/chat-left-text-fill.svg'
                          className='svg-icon-3'
                        />
                      </button>
                    </div>
                  </td>
                  <td className='td-order-2 text-center'>{item['produsen']?.code}</td>
                  {item.sector?.id == 2 ? (
                    <>
                      {item.incoterm2 == null ? (
                        <td className='text-center'>
                          {item.incoterm1?.code}-{item.incoterm2_id}
                        </td>
                      ) : (
                        <td className='text-center'>
                          {item.incoterm1?.code}-{item.incoterm2?.code}
                        </td>
                      )}
                    </>
                  ) : (
                    <>
                      {item.incoterm2 == null ? (
                        <td className='text-center'>
                          {item.incoterm1?.code}
                          {item.incoterm2_id == null || item.incoterm2_id == '0'
                            ? ''
                            : '-' + item.incoterm2_id}
                        </td>
                      ) : (
                        <td className='text-center'>
                          {item.incoterm1?.code}-{item.incoterm2?.code}
                        </td>
                      )}
                    </>
                  )}

                  <td className='td-order-2 text-center'>{item['product_type']}</td>
                  <td className='td-order-2 text-center'>{item['product_name']}</td>
                  <td className='td-order-2 text-center'>{item['product_spec']}</td>
                  <td className='td-order-2 text-center'>
                    {item['request_price']?.toLocaleString()}
                  </td>
                  <td className='td-order-2 text-center'>
                    {item['fixed_price']?.toLocaleString()}
                  </td>
                  <td className='td-order-2 text-center'>
                    {item['request_quantum']?.toLocaleString()}
                  </td>
                  <td className='td-order-2 text-center'>
                    {item['fixed_quantum']?.toLocaleString()}
                  </td>
                  <td className='td-order-2 text-center'>
                    {item.province?.region_name}, {item.city?.city_name}
                  </td>
                  <td className='td-order-2 text-center'>{item.plant_desc}</td>
                </tr>
              </tbody>
            ))}
          </table>
          {/* End Table Head */}
        </div>

        <div className='d-flex align-items-center mb-5' style={{marginTop: '3rem'}}>
          <button className='btn btn-warning td-100 me-2' onClick={() => negoSemua()}>
            Nego
          </button>
        </div>
      </div>
    </div>
  )
}

export {OrderDetailSales}
